import React from "react";

const Spacer = (props) => {
    return <div className="spacer" style={props.style} {...props}></div>

}


export default Spacer;